import {
	CheckOutlined,
	CodeSandboxOutlined,
	FileDoneOutlined,
	FileOutlined,
	FileSyncOutlined,
	FileTextOutlined,
	FileProtectOutlined,
	FlagOutlined,
	HomeOutlined,
	HistoryOutlined,
	MinusSquareOutlined,
	PlusOutlined,
	ShoppingCartOutlined,
	SettingOutlined,
	ShoppingOutlined,
	UnorderedListOutlined,
	UsergroupAddOutlined,
	UserOutlined,
	UserSwitchOutlined,
	WalletOutlined,
	CalculatorOutlined,
	ProjectOutlined,
	ExperimentOutlined,
	CalendarOutlined,
	BarChartOutlined,
	SwapOutlined,
	DeleteOutlined,
	DatabaseOutlined,
	InboxOutlined,
	WarningOutlined,
	ReconciliationOutlined,
	ClockCircleOutlined,
	DollarOutlined,
	TeamOutlined,
	SendOutlined,
	ClusterOutlined,
	PrinterOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React from "react";
import { NavLink } from "react-router-dom";
// import styles from "./Sidenav.module.css";

const Sidenav = ({ color, sideNavOpenKeys }) => {
	const menu = [
		{
			label: (
				<NavLink to='/dashboard'>
					<span>Dashboard</span>
				</NavLink>
			),
			key: "dashboard",
			icon: <HomeOutlined />,
		},
		{
			label: "COST ESTIMATION",
			key: "costEstimation",
			icon: <CalculatorOutlined />,
			children: [
				{
					label: (
						<NavLink to='/calculate-rate'>
							<span>Box Rate (L×B×H)</span>
						</NavLink>
					),
					key: "singleBoxRate",
					icon: <CalculatorOutlined />,
				},
				{
					label: (
						<NavLink to='/sheet-size-calculator'>
							<span>Sheet Size Rate (RS×CS)</span>
						</NavLink>
					),
					key: "sheetSizeRate",
					icon: <CalculatorOutlined />,
				},
				{
					label: (
						<NavLink to='/batch-calculator'>
							<span>Batch Rate Calculator</span>
						</NavLink>
					),
					key: "batchRateCalc",
					icon: <CalculatorOutlined />,
				},
				{
					label: (
						<NavLink to='/rate-logs'>
							<span>Rate Log</span>
						</NavLink>
					),
					key: "rateLogs",
					icon: <HistoryOutlined />,
				},
				{
					label: (
						<NavLink to='/quotation/new'>
							<span>New Quotation</span>
						</NavLink>
					),
					key: "newQuotation",
					icon: <PlusOutlined />,
				},
				{
					label: (
						<NavLink to='/quotation'>
							<span>All Quotations</span>
						</NavLink>
					),
					key: "quotationList",
					icon: <UnorderedListOutlined />,
				},
			],
		},
		{
			label: "ORDERS",
			key: "orders",
			icon: <FileProtectOutlined />,
			children: [
				{
					label: (
						<NavLink to='/order/new'>
							<span>New Order</span>
						</NavLink>
					),
					key: "newOrder",
					icon: <PlusOutlined />,
				},
				{
					label: (
						<NavLink to='/order'>
							<span>All Orders</span>
						</NavLink>
					),
					key: "orderList",
					icon: <UnorderedListOutlined />,
				},
			],
		},
		{
			label: "PRODUCTION",
			key: "production",
			icon: <ProjectOutlined />,
			children: [
				{
					label: (
						<NavLink to='/production/kanban'>
							<span>Kanban Board</span>
						</NavLink>
					),
					key: "kanbanBoard",
					icon: <ProjectOutlined />,
				},
				{
					label: (
						<NavLink to='/production/scheduling'>
							<span>Scheduling</span>
						</NavLink>
					),
					key: "scheduling",
					icon: <CalendarOutlined />,
				},
				{
					label: (
						<NavLink to='/production/batch-planning'>
							<span>Batch Planning</span>
						</NavLink>
					),
					key: "batchPlanning",
					icon: <ProjectOutlined />,
				},
				{
					label: (
						<NavLink to='/production/batch-kanban'>
							<span>Batch Board</span>
						</NavLink>
					),
					key: "batchBoard",
					icon: <ClusterOutlined />,
				},
				{
					label: (
						<NavLink to='/machine'>
							<span>Machines</span>
						</NavLink>
					),
					key: "machineList",
					icon: <SettingOutlined />,
				},
				{
					label: (
						<NavLink to='/job'>
							<span>Jobs</span>
						</NavLink>
					),
					key: "jobList",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to='/mrp'>
							<span>MRP Planning</span>
						</NavLink>
					),
					key: "mrpPlanning",
					icon: <ExperimentOutlined />,
				},
				{
					label: (
						<NavLink to='/outsource'>
							<span>Outsource Jobs</span>
						</NavLink>
					),
					key: "outsourceJobs",
					icon: <SwapOutlined />,
				},
				{
					label: (
						<NavLink to='/wastage'>
							<span>Wastage & Buffer</span>
						</NavLink>
					),
					key: "wastageBuffer",
					icon: <DeleteOutlined />,
				},
				{
					label: (
						<NavLink to='/dispatch-planning'>
							<span>Dispatch Planning</span>
						</NavLink>
					),
					key: "dispatchPlanning",
					icon: <SendOutlined />,
				},
			],
		},
		{
			label: "INVENTORY",
			key: "inventory",
			icon: <DatabaseOutlined />,
			children: [
				{
					label: (
						<NavLink to='/inventory'>
							<span>Inventory Dashboard</span>
						</NavLink>
					),
					key: "inventoryDashboard",
					icon: <DatabaseOutlined />,
				},
				{
					label: (
						<NavLink to='/inventory/raw-materials'>
							<span>Raw Materials (Consumables)</span>
						</NavLink>
					),
					key: "rawMaterials",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to='/inventory/non-consumables'>
							<span>Non-Consumables</span>
						</NavLink>
					),
					key: "nonConsumables",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to='/inventory/add-stock'>
							<span>Add Inventory</span>
						</NavLink>
					),
					key: "quickStockEntry",
					icon: <PlusOutlined />,
				},
				{
					label: (
						<NavLink to='/inventory/history'>
							<span>Consumption History</span>
						</NavLink>
					),
					key: "inventoryHistory",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to='/inventory/settlement'>
							<span>Inventory Settlement</span>
						</NavLink>
					),
					key: "inventorySettlement",
					icon: <ReconciliationOutlined />,
				},
				{
					label: (
						<NavLink to='/inventory/grn'>
							<span>GRN (Goods Receipt)</span>
						</NavLink>
					),
					key: "grnList",
					icon: <ReconciliationOutlined />,
				},
				{
					label: (
						<NavLink to='/inventory/shortages'>
							<span>Material Shortages</span>
						</NavLink>
					),
					key: "materialShortages",
					icon: <WarningOutlined />,
				},
				{
					label: (
						<NavLink to='/inventory/excess'>
							<span>Excess Stock</span>
						</NavLink>
					),
					key: "excessStock",
					icon: <InboxOutlined />,
				},
			],
		},
		{
			label: "PRODUCT",
			key: "product",
			icon: <CodeSandboxOutlined />,
			children: [
				{
					label: (
						<NavLink to='/product'>
							<span>Running Sizes</span>
						</NavLink>
					),
					key: "products",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to='/running-size/bulk-add'>
							<span>Bulk Add Running Sizes</span>
						</NavLink>
					),
					key: "bulkAddRunningSize",
					icon: <PlusOutlined />,
				},
				{
					label: (
						<NavLink to='/product-category'>
							<span>Product Category</span>
						</NavLink>
					),
					key: "productCategory",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to='/product-subcategory'>
							<span>Product Subcategory</span>
						</NavLink>
					),
					key: "productSubcategory",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to='/product-brand'>
							<span>Product Brand</span>
						</NavLink>
					),
					key: "productBrand",
					icon: <UnorderedListOutlined />,
				},
			],
		},
		{
			label: (
				<NavLink to='/pos'>
					<span>POS</span>
				</NavLink>
			),
			key: "pos",
			icon: <ShoppingCartOutlined />,
		},
		{
			label: "PURCHASE",
			key: "purchase",
			icon: <ShoppingOutlined />,
			children: [
				{
					label: (
						<NavLink to='/supplier'>
							<span>Suppliers</span>
						</NavLink>
					),
					key: "suppliers",
					icon: <UserOutlined />,
				},
				{
					label: (
						<NavLink to='/purchase'>
							<span>New Purchase</span>
						</NavLink>
					),
					key: "newPurchase",
					icon: <CheckOutlined />,
				},
				{
					label: (
						<NavLink to='/purchaselist'>
							<span>Purchase List</span>
						</NavLink>
					),
					key: "purchaseList",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to='/outsource/vendors/performance'>
							<span>Supplier Performance</span>
						</NavLink>
					),
					key: "vendorPerformance",
					icon: <BarChartOutlined />,
				},
			],
		},
		{
			label: "SALE",
			key: "sale",
			icon: <MinusSquareOutlined />,
			children: [
				{
					label: (
						<NavLink to='/customer'>
							<span>Customers</span>
						</NavLink>
					),
					key: "customers",
					icon: <UserOutlined />,
				},
				{
					label: (
						<NavLink to='/salelist'>
							<span>Sale List</span>
						</NavLink>
					),
					key: "saleList",
					icon: <UnorderedListOutlined />,
				},
			],
		},
		
		{
			label: "ACCOUNTS",
			key: "accounts",
			icon: <WalletOutlined />,
			children: [
				{
					label: (
						<NavLink to='/account/'>
							<span>Account</span>
						</NavLink>
					),
					key: "accountList",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to='/transaction/create'>
							<span>New Transaction</span>
						</NavLink>
					),
					key: "newTransaction",
					icon: <CheckOutlined />,
				},
				{
					label: (
						<NavLink to='/transaction/'>
							<span>Transaction List</span>
						</NavLink>
					),
					key: "transactionList",
					icon: <UnorderedListOutlined />,
				},
			],
		},
		{
			label: "REPORT",
			key: "report",
			icon: <FlagOutlined />,
			children: [
				{
					label: (
						<NavLink to='/account/trial-balance'>
							<span>Trial Balance</span>
						</NavLink>
					),
					key: "trialBalance",
					icon: <FileDoneOutlined />,
				},
				{
					label: (
						<NavLink to='/account/balance-sheet'>
							<span>Balance Sheet</span>
						</NavLink>
					),
					key: "balanceSheet",
					icon: <FileOutlined />,
				},
				{
					label: (
						<NavLink to='/account/income'>
							<span>Income Statement</span>
						</NavLink>
					),
					key: "incomeStatement",
					icon: <FileSyncOutlined />,
				},
			],
		},

		{
			label: "HR",
			key: "hr",
			icon: <UserOutlined />,
			children: [
				{
					label: (
						<NavLink to='/hr/staffs'>
							<span>Staffs</span>
						</NavLink>
					),
					key: "staffs",
					icon: <UsergroupAddOutlined />,
				},
				{
					label: (
						<NavLink to='/role'>
							<span>Role & Permissions</span>
						</NavLink>
					),
					key: "roleAndPermissions",
					icon: <UserSwitchOutlined />,
				},
				{
					label: (
						<NavLink to='/designation/'>
							<span>Designation</span>
						</NavLink>
					),
					key: "designation",
					icon: <UserSwitchOutlined />,
				},
				{
					label: (
						<NavLink to='/hr/workers'>
							<span>Workers</span>
						</NavLink>
					),
					key: "workers",
					icon: <TeamOutlined />,
				},
				{
					label: (
						<NavLink to='/hr/attendance'>
							<span>Attendance</span>
						</NavLink>
					),
					key: "attendance",
					icon: <ClockCircleOutlined />,
				},
				{
					label: (
						<NavLink to='/hr/advance'>
							<span>Advance</span>
						</NavLink>
					),
					key: "advance",
					icon: <DollarOutlined />,
				},
				{
					label: (
						<NavLink to='/hr/salary'>
							<span>Salary Sheet</span>
						</NavLink>
					),
					key: "salarySheet",
					icon: <ReconciliationOutlined />,
				},
			],
		},

		{
			label: "SETTINGS",
			key: "settings",
			icon: <SettingOutlined />,
			children: [
				{
					label: (
						<NavLink to='/invoice-setting'>
							<span>Invoice Settings</span>
						</NavLink>
					),
					key: "invoiceSetting",
					icon: <SettingOutlined />,
				},
				{
					label: (
						<NavLink to='/settings/production-flow'>
							<span>Production Flows</span>
						</NavLink>
					),
					key: "productionFlow",
					icon: <ProjectOutlined />,
				},
				{
					label: (
						<NavLink to='/settings/stage-config'>
							<span>Stage Configuration</span>
						</NavLink>
					),
					key: "stageConfig",
					icon: <ReconciliationOutlined />,
				},
				{
					label: (
						<NavLink to='/settings/print-templates'>
							<span>Print Templates</span>
						</NavLink>
					),
					key: "printTemplates",
					icon: <PrinterOutlined />,
				},
				{
					label: (
						<NavLink to='/settings/layer-templates'>
							<span>Layer Templates</span>
						</NavLink>
					),
					key: "layerTemplates",
					icon: <ReconciliationOutlined />,
				},
			],
		},
	];

	return (
		<div>
			<Menu
				theme='dark'
				mode='inline'
				items={menu}
				className='sidenav-menu'
				// openKeys={[sideNavOpenKeys]}
				// style={{ backgroundColor: "transparent" }}
			/>
		</div>
	);
};

export default Sidenav;
